
import { AlertTriangle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface TooManyResultsErrorProps {
  searchTerm: string;
  totalItemsFromAPI?: number;
  maxAllowedItems?: number;
  context: 'search' | 'alert';
}

const TooManyResultsError = ({ searchTerm, totalItemsFromAPI, maxAllowedItems, context }: TooManyResultsErrorProps) => {
  // Use backend-provided limit, fallback to 10 if not provided
  const maxAllowed = maxAllowedItems || 10;
  
  return (
    <Card className="border-red-200 bg-red-50">
      <CardContent className="pt-6">
        <div className="flex items-start space-x-3">
          <AlertTriangle className="h-5 w-5 text-red-500 mt-0.5" />
          <div className="flex-1">
            <h3 className="font-semibold text-red-800 mb-2">
              {context === 'alert' ? 'Alert Creation Failed' : 'Search Term Too Broad'}
            </h3>
            <p className="text-red-700 text-sm mb-2">
              Your search term "<strong>{searchTerm}</strong>" returned {totalItemsFromAPI} results, 
              which exceeds our maximum limit of {maxAllowed} items per search.
            </p>
            <p className="text-red-600 text-sm">
              {context === 'alert' 
                ? 'Please try again with a more specific search term to create your alert.'
                : 'Please try again with a more specific search term to see detailed results.'
              }
            </p>
            <div className="mt-3 text-xs text-red-600">
              <strong>Tips for better searches:</strong>
              <ul className="list-disc list-inside mt-1 space-y-1">
                <li>Include specific brand names (e.g., "Eagle Rare" instead of "bourbon")</li>
                <li>Use exact product names when possible</li>
              </ul>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TooManyResultsError;
